(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {

	// ----------------------------------------------------------
	// .j_sliderMain
	// ----------------------------------------------------------

	$('.j_sliderMain').slick({
		// pauseOnHover: false,
		autoplay: true,
		dots: true,
		centerMode: true,
		centerPadding: '25%',
		speed: 600,
		autoplaySpeed: 5000,
		responsive: [{
			breakpoint: 601,
			settings: {
				centerMode: false
			}
		}]
	});

	$(".j_sliderMain").on({
		"mouseenter": function mouseenter() {
			$('.j_sliderMain .slick-slide:not(.slick-center)').addClass('no-center');
		},
		"mouseleave": function mouseleave() {
			$('.j_sliderMain .slick-slide:not(.slick-center)').removeClass('no-center');
		}
	}, ".slick-center");

	// ----------------------------------------------------------
	// .j_sliderMainSmall
	// ----------------------------------------------------------

	$('.j_sliderMainSmall').slick({
		// pauseOnHover: false,
		autoplay: true,
		dots: true,
		centerMode: true,
		centerPadding: '26%',
		speed: 600,
		autoplaySpeed: 5000,
		responsive: [{
			breakpoint: 601,
			settings: {
				centerPadding: '15%',
				centerMode: true
			}
		}]
	});

	$(".j_sliderMainSmall").on({
		"mouseenter": function mouseenter() {
			$('.j_sliderMainSmall .slick-slide:not(.slick-center)').addClass('no-center');
		},
		"mouseleave": function mouseleave() {
			$('.j_sliderMainSmall .slick-slide:not(.slick-center)').removeClass('no-center');
		}
	}, ".slick-center");

	// ----------------------------------------------------------
	// .j_sliderLinkArea
	// ----------------------------------------------------------

	$('.j_sliderLinkArea').slick({
		pauseOnHover: false,
		autoplay: true,
		speed: 900,
		autoplaySpeed: 6000,
		dots: true
	});

	// ボタンリンク設定
	$('.sliderLinkArea .btn').on('click', function (e) {
		var index = $(e.currentTarget).parents('.sliderLinkArea').find('.btn').index(e.currentTarget) + 1;
		window.location.href = $(e.currentTarget).parents('.sliderLinkArea').find('.slick-active').attr('data-link' + index);
		e.preventDefault();
	});

	// スライドStart
	$('.j_sliderLinkArea').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(event.currentTarget).addClass('isChange');
	});
	// スライドEnd
	$('.j_sliderLinkArea').on('afterChange', function (event, slick, currentSlide) {
		$(event.currentTarget).removeClass('isChange');
	});

	// ----------------------------------------------------------
	// .j_sliderCaption
	// ----------------------------------------------------------

	$('.j_sliderCaption').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [{
			breakpoint: 601,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '95px',
				slidesToShow: 1
			}
		}, {
			breakpoint: 401,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '70px',
				slidesToShow: 1
			}
		}]
	});

	// ----------------------------------------------------------
	// .j_sliderImg
	// ----------------------------------------------------------

	$('.j_sliderImg').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		responsive: [{
			breakpoint: 601,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '80px',
				slidesToShow: 3
			}
		}, {
			breakpoint: 501,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '60px',
				slidesToShow: 2
			}
		}, {
			breakpoint: 401,
			settings: {
				arrows: false,
				centerMode: true,
				centerPadding: '90px',
				slidesToShow: 1
			}
		}]
	});

	// ----------------------------------------------------------
	// .j_sliderBnr
	// ----------------------------------------------------------

	$('.j_sliderBnr').slick({
		autoplay: true,
		pauseOnHover: false,
		dots: true
	});

	// ----------------------------------------------------------
	// .j_sliderProduct
	// ----------------------------------------------------------


	$('.j_sliderProduct').slick({
		pauseOnHover: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		dots: true,
		dotsClass: 'dot-thum'
	});

	// スライダ画像をサムネイルとして設置
	var $sliderProduct = $('.j_sliderProduct');
	if ($sliderProduct.length) {

		for (var i = 0; i < $sliderProduct.length; i++) {

			var $slideData = $sliderProduct.eq(i).slick('getSlick').$slides;

			for (var j = 0; j < $slideData.length; j++) {

				var $slideImg = $slideData[j].innerHTML;

				$sliderProduct.eq(i).find('.dot-thum li').eq(j).html($slideImg);
			}
		}
	}

	// ----------------------------------------------------------
	// .j_sliderRecommendedImg
	// ----------------------------------------------------------

	$('.j_sliderRecommendedImg').slick({
		pauseOnHover: false,
		autoplay: false,
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerPadding: '20%',
		asNavFor: '.j_sliderRecommendedDetail',
		responsive: [{

			breakpoint: 601,
			settings: {
				centerPadding: '36%',
				slidesToShow: 1
			}
		}]
	});
	// ----------------------------------------------------------
	// .j_sliderRecommendedDetail
	// ----------------------------------------------------------

	$('.j_sliderRecommendedDetail').slick({
		pauseOnHover: false,
		autoplay: false,
		dots: true,
		centerMode: true,
		centerPadding: '0',
		asNavFor: '.j_sliderRecommendedImg'
	});

	// ----------------------------------------------------------
	// .j_sliderChooseModel
	// ----------------------------------------------------------

	if ($('.j_sliderChooseModel').length > 0) {

		for (var i = 0; i < $('.j_sliderChooseModel').length; i++) {

			// .j_sliderChooseModel
			// ----------------------------------------------------------


			$('.j_sliderChooseModel:eq(' + i + ')').on('init', function (event, slick) {
				$('.j_sliderChooseModel:eq(' + i + ')').css("opacity", 1);
			});

			$('.j_sliderChooseModel:eq(' + i + ')').slick({
				pauseOnHover: false,
				autoplay: false,
				dots: false,
				centerMode: true,
				focusOnSelect: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				centerPadding: '20%',
				asNavFor: '.j_sliderChooseModelDetail:eq(' + i + ')',
				responsive: [{

					breakpoint: 601,
					settings: {
						centerPadding: '36%',
						slidesToShow: 1
					}
				}]
			});

			// .j_sliderRecommendedDetail
			// ----------------------------------------------------------

			$('.j_sliderChooseModelDetail:eq(' + i + ')').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: false,
				arrows: false,
				swipe: false,
				fade: true,
				asNavFor: '.j_sliderChooseModel:eq(' + i + ')'
			});
		}
	}

	// ----------------------------------------------------------
	// .j_sliderChooseSimpleModel
	// ----------------------------------------------------------

	$('.j_sliderChooseSimpleModel').on('init', function (event, slick) {
		$('.j_sliderChooseSimpleModel').css("opacity", 1);
	});

	$('.j_sliderChooseSimpleModel').slick({
		pauseOnHover: false,
		autoplay: false,
		dots: false,
		centerMode: true,
		focusOnSelect: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		centerPadding: '20%',
		responsive: [{
			breakpoint: 601,
			settings: {
				centerPadding: '36%',
				slidesToShow: 1
			}
		}]
	});
};

},{}],2:[function(require,module,exports){
'use strict';

var _slider = require('./common/slider');

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

////

var Init = function Init() {

	(0, _slider2.default)();
};

Init();

},{"./common/slider":1}]},{},[2])

